<template>
  <div>
    <vs-popup :active.sync="showCredentialsPopup" title="Informations de connexion">
      <vs-table v-if="selectedDns" noDataText="" stripe auto-resize>
        <template slot="thead">
          <vs-th>Login</vs-th>
          <vs-th>Mot de passe</vs-th>
          <vs-th>Port</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td><span>{{ selectedDns.login }}</span></vs-td>
            <vs-td><span>{{ selectedDns.pass }}</span></vs-td>
            <vs-td><span>{{ selectedDns.port }}</span></vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir valider la supression du nom de domaine ?">
      <div class="vx-row">
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="accept()">Oui</vs-button>
        </div>
        <div class="vx-col sm:w-1/2">
          <vs-button color="primary" class="mt-2 w-full" @click="decline()">Non</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-table :data="dns" stripe :max-height= "tableHeight + 'px'">
      <template slot="thead">
        <vs-th class="th-sticky pdl0">NOM DE DOMAINE</vs-th>
        <vs-th class="th-sticky pdl0">SECTEUR d'ACTIVITE</vs-th>
        <vs-th class="th-sticky pdl0">LANGUE</vs-th>
        <vs-th class="th-sticky pdl0">PRESTATAIRE</vs-th>
        <vs-th class="th-sticky"><div class="w-full" style="text-align: right !important;">PRIX</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">DATE D'ACHAT</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">RENOUVELLEMENT (MOIS)</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">DOMAIN AUTHORITY</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">DOMAINES REFERENTS</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">LIENS ENTRANTS</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">CLIENTS DESSUS</div></vs-th>
        <vs-th class="th-sticky"><div class="w-full text-center">LIENS TOTAUX (TOUS CLIENTS)</div></vs-th>
        <vs-th class="th-sticky pdl0"><div class="w-full text-center">STATUT</div></vs-th>
        <vs-th class="th-sticky"></vs-th>
        <vs-th class="th-sticky"></vs-th>
        <vs-th class="th-sticky"></vs-th>
        <vs-th class="th-sticky" v-if="$acl.check('sadmin')"></vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(oneDns, index) in data">
			<div v-show="false">
				{{setRowNum(data.length)}}
			</div>

          <vs-td :data="oneDns.host"><a class="hvr-underline hvr-underline-out" :href="urlPrefixAdder(oneDns.host)" target="_blank">{{ oneDns.host }}</a></vs-td>
          <vs-td :data="oneDns.domain_activity">{{ oneDns.domain_activity }}</vs-td>
          <vs-td :data="oneDns.lang">{{ getLangIdToName(oneDns.lang) }}</vs-td>
          <vs-td :data="oneDns.provider_id">{{ getProviderIdToName(oneDns.provider_id) }}</vs-td>
          <vs-td :data="oneDns.price" class="pdl0" style="text-align: right;">{{ oneDns.price }}€</vs-td>
          <vs-td :data="oneDns.purchase_date" class="pdl0" style="text-align: center;">{{ oneDns.purchase_date ? getDateToFrenchFormat(oneDns.purchase_date.substring(0,10)) : "" }}</vs-td>
          <vs-td :data="oneDns.before_renew_duration" class="pdl0" style="text-align: center;">{{ oneDns.before_renew_duration ? getDateToFrenchFormat(getDateWithDuration(oneDns.renew_date.substring(0,10), oneDns.before_renew_duration)) : " " }}</vs-td>
          <vs-td :data="oneDns.domain_authority" style="text-align: center;"><div class="chip"><strong>{{ oneDns.domain_authority }}</strong></div></vs-td>
          <vs-td :data="oneDns.referring_domains" style="text-align: center;"><div class="chip"><strong>{{ oneDns.referring_domains != 0 ? formatThousandNumb(oneDns.referring_domains) : 0 }}</strong></div></vs-td>
          <vs-td :data="oneDns.referring_links" style="text-align: center;"><div class="chip"><strong>{{ oneDns.referring_links != 0 ? formatThousandNumb(oneDns.referring_links) : 0 }}</strong></div></vs-td>
          <vs-td :data="oneDns.society_counter" style="text-align: center;"><span class="hvr-underline hvr-underline-out" @click="displaySocieties(oneDns.id)">{{ oneDns.society_counter }}</span></vs-td>
          <vs-td :data="oneDns.total_links" style="text-align: center;"><span class="hvr-underline hvr-underline-out" @click="displayNetlinks(oneDns.id)">{{ oneDns.total_links }}</span></vs-td>
          <vs-td :data="oneDns.status" style="display: flex; justify-content: center; margin-top: 9px;" class="pdl0">
            <vs-chip style="width: 80px; margin-right: 0 !important;"
              :color="getContractStatusColor(oneDns.status)">
              {{
                getContractStatus(oneDns.status)
              }}
            </vs-chip>
          </vs-td>
          <vs-td style="text-align: center;">
            <vx-tooltip text="Informations de connexion" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
              <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-eye"
                         @click="displayCredentials(oneDns)">
              </vs-button>
            </vx-tooltip>
          </vs-td>
          <!--
          <vs-td :data="oneDns.anchor_type">{{ getNetlinkAnchorType(oneDns.anchor_type) }}</vs-td>
          <vs-td :data="oneDns.link_type">{{ getNetlinkLinkType(oneDns.link_type) }}</vs-td>
          <vs-td :data="oneDns.purchase_id"> {{ oneDns.creation_date ? getDateToFrenchFormat(oneDns.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(oneDns.purchase_id)) }}</vs-td>
          <vs-td :data="oneDns.status">
            <vs-chip
              style="width: 80px"
              :color="getNetlinkStatusColor(oneDns.status)"
              class="ml-2"
              >{{
              getNetlinkStatus(oneDns.status)
            }}</vs-chip></vs-td> -->
          <vs-td style="text-align: center;">
            <vx-tooltip text="Ajouter" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
              <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-plus-circle"
                         @click="$router.push({ name: 'new_entity', params: { newEntityForm: 'netlink', dns: oneDns.id } })"></vs-button>
            </vx-tooltip>
          </vs-td>
          <vs-td style="text-align: center;">
            <vx-tooltip text="Modifier" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
              <vs-button size="large"
                         color="primary"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-edit-2"
                         @click="updateDns(oneDns)"></vs-button>
            </vx-tooltip>
          </vs-td>
          <vs-td v-if="$acl.check('sadmin')" style="text-align: center;">
            <vx-tooltip text="Effacer" position="top" style="text-align: -webkit-center; margin-right: 0 !important;">
              <vs-button size="large"
                         color="danger"
                         type="flat"
                         icon-pack="feather"
                         icon="icon-trash-2"
                         @click="displayValidationPopup(oneDns)"></vs-button>
            </vx-tooltip>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/store/store";
import utilsMixin from "@/mixins/utilsMixin.js";
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
// import Purchase from "@/entities/Purchase"
import Dns from "@/entities/Dns";

export default {
	name: "DnsTable",
	props: {
		dns: Array,
		// services: Array,
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	components: {
	},
	data() {
		return {
			apiErrorMsg: null, // catching api error message
			showCredentialsPopup: false,
			showValidationPopup: false,
			dnsToDelete: null,
			selectedDns: null,
			langList: [
				{name: "Français", country: "France", id: 1},
				{name: "Anglais", country: "USA", id: 2},
				{name: "Anglais", country: "UK", id: 3},
				{name: "Chinois simplifié", country: "RPC", id: 4},
				{name: "Japonais", country: "Japon", id: 5},
				{name: "Coréen", country: "Corée du Sud", id: 6},
			],
		};
	},
	created() {
		// this.getAllSocieties()
		if(this.$props.dns.length == 0){
				this.setRowNum(0);
			}
		this.getAllProviders();
		/*
		 * this.getAllServices()
		 * this.getAllPurchases();
		 */
	},
	mounted() {
		store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.09*this.windowHeigth));
		this.$nextTick(() => {
			window.addEventListener("resize", () => {
				store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.09*this.windowHeigth));
			});

		});
	},
	computed: {
		filterCardHeight: () => {
			return store.state.filterCardHeight;
		},
		isFilterDown: () => {
			return store.state.isFilterDown;
		},
		horizentalNavBarHeight: () => {
			return store.state.horizentalNavBarHeight;
		},
		windowHeigth: () => {
			return store.state.windowHeigth;
		},
		tableHeight: () => {
			return store.state.tableHeight ;
		},
		/*
		 * societies: () => {
		 *   return store.state.societies;
		 * },
		 */
		providers: () => {
			return store.state.providers;
		},
		/*
		 * services: () => {
		 *   return store.state.services;
		 * },
		 * purchases: () => {
		 *   return store.state.purchases;
		 * },
		 */
	},
	watch: {
		isFilterDown: function(){
			store.dispatch("updateFilterCardHeight", document.getElementById("fliterCard").clientHeight);
			store.dispatch("updateTableHeight", (this.windowHeigth-this.horizentalNavBarHeight)-this.filterCardHeight-(0.09*this.windowHeigth));
		},
		dns: function(data){
			if(data.length == 0) this.setRowNum(0);
		}
		/*
		 * purchases: function(){
		 *     //console.log("purchases watch")
		 *     // this.createChips(this.providers)
		 * }
		 */
	},

	methods: {
		setRowNum(len){
			store.dispatch("setRowNum", len);
		},

		displaySocieties(dns_id){
			this.$emit("display-societies", dns_id);
		},
		displayNetlinks(dns_id){
			this.$emit("display-netlinks", dns_id);
		},
		displayCredentials(dns) {
			this.selectedDns = dns;
			this.showCredentialsPopup = true;
		},
		/**
		 * Fetch all the purchases
		 */
		/*
		 * getAllPurchases() {
		 *   ////console.log("getAllNetlink BEGIN")
		 *   this.$store.dispatch("getAllPurchases");
		 *   ////console.log("getAllNetlink END")
		 * },
		 */

		/**
		 * Add prefix to url using the mixin
		 */
		getPrefixedUrl(url) {
			return this.urlPrefixAdder(url);
		},

		/**
		 * Returns service name from service id
		 * @param {Number} service_id - service id to retrieve name from
		 * @return {String} - name of service id
		 */
		/*
		 * getServiceIdToName(service_id){
		 *   let service_name = ""
		 *   let service = this.services.find(service => service.id == service_id)
		 *   service_name = service.name;
		 *   return service_name
		 * },
		 */

		/*
		 * getSocietyIdToName(society_id){
		 *   let society_name = ""
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name;
		 *   return society_name
		 * },
		 */

		getProviderIdToName(provider_id){
			// let provider_name = ""
			let provider = this.providers.find(provider => provider.id == provider_id);
			let provider_name = provider ? provider.society : "";
			return provider_name;
		},

		getLangIdToName(lang_id){
			// let provider_name = ""
			let lang = this.langList.find(lang => lang.id == lang_id);
			let lang_name = lang ? `${lang.name} (${lang.country})` : "";
			return lang_name;
		},



		/*
		 * getSocietyName(society_id){
		 *   let society_name = ""
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name
		 *   return society_name
		 * },
		 */

		/*
		 * getPurchaseIdToSocietyName(purchase_id){
		 *   let society_name = ""
		 *   let purchase = this.purchases.find(purchase => purchase.id == purchase_id)
		 *   let society_id = purchase.contract_society_id;
		 *   let society = this.societies.find(society => society.id == society_id)
		 *   society_name = society.name
		 *   return society_name
		 * },
		 */

		/*
		 * getPurchaseIdToPurchaseDate(purchase_id){
		 *   let purchase_date = ""
		 *   let purchase = this.purchases.find(purchase => purchase.id == purchase_id)
		 *   purchase_date = purchase.bought_at
		 *   return purchase_date.substring(0,10)
		 * },
		 */

		formatDate(date_input){
			if(date_input && date_input.length > 10){
				return date_input.substring(0, 10);
			}
			else{
				return date_input;
			}
		},
		// getAllServices(){
		//   this.$store.dispatch("getAllServices");
		// },
		// /**
		//  * Get all societies in store states
		//  */
		// getAllSocieties(){
		//   this.$store.dispatch("getAllSocieties");
		// },
		getAllProviders(){
			this.$store.dispatch("getAllProviders");
		},

		deleteDns(dns){
			// let netlinkToDelete = new Netlink(netlink)
			Dns.delete(dns.id, (err, res) => {
				if(err) //console.log(err);
				if(res) {
					/*
					 *   this.$store.dispatch("getAllPurchases");
					 *   this.$store.dispatch("getAllServices");
					 */
					this.$emit("delete-line", dns);
				}
			});
		},

		updateDns(dns){
			this.$emit("modify-dns", dns);
		},

		displayValidationPopup(dns){
			this.dnsToDelete = dns;
			this.showValidationPopup = true;
		},

		accept(){
			this.deleteDns(this.dnsToDelete);
			this.showValidationPopup = false;
		},

		decline(){
			this.dnsToDelete = null;
			this.showValidationPopup = false;
		}
	}
};
</script>

<style scoped>
.center {
  justify-content: center;
}

.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
.chip {
  text-align: center;
  border-radius: 20px;
  background-color: #f0f0f0;
  padding: 5px 10px;
  font-size: .8rem;
  display: inline-block;
}
</style>
